import API_BASE_URL from './config';
import React, { useState } from 'react';

function RegisterStaff({ playerId }) {
  const [staffName, setStaffName] = useState('');
  const [imageLink, setImageLink] = useState('');
  const [message, setMessage] = useState('');

  const handleAddStaff = async () => {
    if (!playerId) {
      setMessage('Please log in to register a staff member.');
      return;
    }
    if (!staffName || !imageLink) {
      setMessage('Please provide a staff name and an image link.');
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/add-staff`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'player-id': playerId // Changed to player-id header
        },
        body: JSON.stringify({
          playerId,
          staffName,
          imageLink
        })
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setMessage(data.message);
      setStaffName('');
      setImageLink('');
    } catch (error) {
      setMessage('Add staff failed: ' + error.message);
    }
  };

  if (!playerId) return <p style={{ textAlign: 'center', color: '#888' }}>Please log in to register a staff member!</p>;

  const inputStyle = {
    width: '100%',
    padding: '8px',
    marginBottom: '15px',
    borderRadius: '5px',
    border: '1px solid #BBDEFB',
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
    fontSize: '1em'
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#1E88E5',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
    width: '100%'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
    color: '#1E88E5'
  };

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '0 auto', 
      padding: '20px', 
      backgroundColor: '#f9f9f9', 
      borderRadius: '8px', 
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)', 
      border: '1px solid #E6F0FA' 
    }}>
      <h1 style={{ 
        color: '#1E88E5', 
        textAlign: 'center', 
        marginBottom: '20px', 
        fontSize: '1.8em' 
      }}>
        Register a Staff Member
      </h1>
      {message && (
        <p style={{ 
          backgroundColor: '#BBDEFB', 
          padding: '10px', 
          borderRadius: '5px', 
          color: '#333', 
          textAlign: 'center', 
          marginBottom: '20px' 
        }}>
          {message}
        </p>
      )}
      <div>
        <label style={labelStyle} htmlFor="staffName">Staff Name:</label>
        <input
          type="text"
          id="staffName"
          value={staffName}
          onChange={(e) => setStaffName(e.target.value)}
          placeholder="Staff Name"
          style={inputStyle}
          required
        />
      </div>
      <div>
        <label style={labelStyle} htmlFor="imageLink">Image Link (Sta.sh):</label>
        <input
          type="url"
          id="imageLink"
          value={imageLink}
          onChange={(e) => setImageLink(e.target.value)}
          placeholder="https://sta.sh/example"
          style={inputStyle}
          required
        />
      </div>
      <button
        onClick={handleAddStaff}
        style={buttonStyle}
        onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#1E88E5'}
      >
        Submit Staff
      </button>
    </div>
  );
}

export default RegisterStaff;